// extracted by css-extract-rspack-plugin
export default {"logsViewer":"Fapoz"};